export const docToNotifRef = doc => {
  const data = doc.data()
  return {
    key: doc.id,
    read: data.read,
    score: data.score,
    docId: data.notif_ref.id,
    published_at: data.published_at
  }
}

export const docToNotifData = (doc, item) => {
  const prevData = doc.data()
  const data = JSON.parse(JSON.stringify(prevData))
  const postKey = prevData.source && prevData.source.post && prevData.source.post.id
  return {
    ...data,
    key: doc.id,
    postKey: postKey,
    read: item.read,
    score: item.score,
    published_at: item.published_at
  }
}



// WEBPACK FOOTER //
// ./src/converters/notifConverter.js